import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    interval: { type: Number, default: 0 }
  }

  connect() {
    this.index = 0
    this.showSlide(0)
    if (this.intervalValue > 0) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  next(event) {
    event?.stopPropagation?.()
    this.index = (this.index + 1) % this.slideTargets.length
    this.showSlide(this.index)
    this.resetAutoplay()
  }

  prev(event) {
    event?.stopPropagation?.()
    this.index = this.index === 0 ? this.slideTargets.length - 1 : this.index - 1
    this.showSlide(this.index)
    this.resetAutoplay()
  }

  go(event) {
    event.preventDefault()
    event?.stopPropagation?.()
    this.index = parseInt(event.currentTarget.dataset.index, 10)
    this.showSlide(this.index)
    this.resetAutoplay()
  }

  showSlide(index) {
    this.index = index
    this.slideTargets.forEach((slide, i) => {
      const isHidden = i !== index
      slide.classList.toggle("hidden", isHidden)
      slide.classList.toggle("block", i === index)
      if (isHidden) {
        const video = slide.querySelector("video")
        if (video) video.pause()
      }
    })
    if (this.hasIndicatorTarget) {
      this.indicatorTargets.forEach((indicator, i) => {
        indicator.classList.remove("bg-white", "bg-white/50")
        indicator.classList.add(i === index ? "bg-white" : "bg-white/50")
      })
    }
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => this.next(), this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }
  }

  resetAutoplay() {
    if (this.intervalValue > 0) {
      this.stopAutoplay()
      this.startAutoplay()
    }
  }
}
